export default "__VITE_ASSET__BmeLHq60__"